// src/ability/index.ts
import { createContext } from "react";
import { createContextualCan } from "@casl/react";
import type { Ability } from "@casl/ability";
import { ability, abilityStore, defineAbilitiesFor } from "./ability";

// Define the context type
const AbilityContext = createContext<Ability | undefined>(undefined);
const Can = createContextualCan(AbilityContext.Consumer);

export { ability, abilityStore, defineAbilitiesFor, AbilityContext, Can };